export const translations = {
	"Metric tooltip tooltip": {
		en: "Select what to display in the mouseover. You can also add custom entries by typing. They will be shown in selector with blue color.",
		no: "Velg hva som skal vises i musepeker. Du kan også legge til egendefinerte elementer ved å skrive inn. De vil vises med blå farge i feltet."

	}
}
